import type { API } from 'api/config/types';
import { Core } from 'core/config/types';
import { Game } from 'chessboard/model/game/types';

/**
 * Create the playingAs API to manage the playingAs value.
 */
export function createPlayingAsAPI(context: API.Context) {
  let playingAs = Game.ColorsAsNumbers.White;
  let usingPlayingAs = false;

  return {
    getPlayingAs,
    setPlayingAs,
    usePlayingAs,
  };

  /**
   * Get the playingAs value.
   */
  function getPlayingAs(): Game.ColorsAsNumbers | undefined {
    return usingPlayingAs ? playingAs : undefined;
  }

  /**
   * Set the colour that the user is playing as.
   */
  function setPlayingAs(color: Game.ColorsAsNumbers): API.Response | null {
    if (color === playingAs) {
      return null;
    }

    const { respond } = context;

    playingAs = color;

    return respond(Core.APIEvents.SetPlayingAs, color);
  }

  /**
   * Set whether or not the playingAs value should be used.
   */
  function usePlayingAs(use: boolean | undefined) {
    usingPlayingAs = use || false;
  }
}
